import React, { useState } from 'react';
import { FaChevronDown, FaBookOpen, FaLightbulb } from 'react-icons/fa';
// فایل CSS که در مرحله ۴ خواهیم ساخت
import './InteractivePoem.css'; 

// ✅ کامپوننت اکنون داده‌ها را به عنوان "prop" دریافت می‌کند
const InteractivePoem = ({ poemData }) => {
    // از یک state برای نگهداری ID بیتی که باز شده، استفاده می‌کنیم
    const [selectedBaytId, setSelectedBaytId] = useState(null);

    // تابعی که هنگام کلیک روی یک بیت اجرا می‌شود
    const handleBaytClick = (id) => {
        // اگر کاربر دوباره روی بیت باز شده کلیک کرد، آن را ببند
        if (selectedBaytId === id) {
            setSelectedBaytId(null);
        } else {
            // در غیر این صورت، بیت جدید را باز کن
            setSelectedBaytId(id);
        }
    };

    // اگر داده‌ای وجود نداشت یا آرایه نبود، چیزی نمایش نده
    if (!Array.isArray(poemData) || poemData.length === 0) {
        return <p>محتوای شعر در حال بارگذاری است...</p>;
    }

    return (
        <div className="poem-container">
            {poemData.map((bayt) => (
                <div key={bayt.id} className="bayt-wrapper">
                    {/* بخش قابل کلیک (خودِ بیت شعر) */}
                    <div 
                        className="bayt" 
                        onClick={() => handleBaytClick(bayt.id)}
                        aria-expanded={selectedBaytId === bayt.id}
                        role="button"
                        tabIndex={0}
                    >
                        <span className="mesra mesra-1">{bayt.mesra1}</span>
                        <span className="mesra mesra-2">{bayt.mesra2}</span>
                        <FaChevronDown className={`chevron-icon ${selectedBaytId === bayt.id ? 'open' : ''}`} />
                    </div>
                    
                    {/* بخش مخفی (معنی و آرایه‌ها) که فقط در صورت باز بودن نمایش داده می‌شود */}
                    {selectedBaytId === bayt.id && (
                        <div className="details">
                            <div className="detail-section meaning">
                                <h4><FaBookOpen /> معنی بیت</h4>
                                <p>{bayt.meaning}</p>
                            </div>
                            <div className="detail-section analysis">
                                <h4><FaLightbulb /> آرایه‌های ادبی و نکات</h4>
                                <ul>
                                    {bayt.analysis.map((item, index) => (
                                        <li key={index}>{item}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default InteractivePoem;